export type SkeletonPreset = "chart" | "list" | "cards" | "grid";

/** Purely decorative placeholder shown (blurred) behind a locked feature. Renders no real data. */
export default function LockedSkeleton({ preset = "list" }: { preset?: SkeletonPreset }) {
  const block = "bg-black/[0.06] border border-black/[0.04] rounded-lg";
  return (
    <div className="h-full w-full p-4 bg-[#f6f5f2]">
      {preset === "chart" && (
        <div className="flex flex-col gap-3 h-full">
          <div className="flex gap-3">
            <div className={`${block} flex-1 h-14`} />
            <div className={`${block} flex-1 h-14`} />
            <div className={`${block} flex-1 h-14`} />
            <div className={`${block} flex-1 h-14`} />
          </div>
          <div className="flex gap-3 flex-1">
            <div className={`${block} flex-[2] flex items-end gap-2 p-3`}>
              {[38, 62, 48, 82, 58, 72].map((h, i) => (
                <div key={i} className="flex-1 bg-emerald-200/70 rounded-sm" style={{ height: `${h}%` }} />
              ))}
            </div>
            <div className={`${block} flex-1`} />
          </div>
        </div>
      )}
      {preset === "list" && (
        <div className="flex flex-col gap-2.5">
          {Array.from({ length: 7 }).map((_, i) => (
            <div key={i} className={`${block} h-9`} style={{ width: `${95 - i * 6}%` }} />
          ))}
        </div>
      )}
      {preset === "cards" && (
        <div className="grid grid-cols-2 gap-3">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className={`${block} h-24`} />
          ))}
        </div>
      )}
      {preset === "grid" && (
        <div className="grid grid-cols-3 gap-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className={`${block} h-20`} />
          ))}
        </div>
      )}
    </div>
  );
}
